
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signupworker",
      function () {
        return require("private-next-pages/signupworker.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signupworker"])
      });
    }
  